import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $cardUsersStore, $usersListStore } from '@lib/store';
import { cn, PaletteUtils, RoutePaths } from '@shared/utils';
import { UserType } from '@shared/api/rest/users';
import { AddUsersModal, RemoveUsersModal, UserItem } from '@widgets';
import { Button, NoData, Spinner, Text } from '@shared/widgets';

interface UsersProps {
  className?: string;
  cardId: string;
}

export const Users = (props: UsersProps) => {
  const usersListStore = useUnit($usersListStore.store);
  const cardUsersStore = useUnit($cardUsersStore.store);

  const [showAddUsersModal, setShowAddUsersModal] = useState<boolean>(false);
  const [showRemoveUsersModal, setShowRemoveUsersModal] = useState<boolean>(false);

  const { t } = useTranslation('card');

  useEffect(() => {
    $cardUsersStore.events.getCardUsers({ AssignedCardId: parseInt(props.cardId) });
    $usersListStore.events.getUsers({ UserType: UserType.USER });
  }, []);

  return (
    <>
      <div className={cn('mb-12', PaletteUtils.isVcfcPalette && 'px-9', props.className)}>
        <div className='mb-6 flex flex-wrap items-center justify-between'>
          <Text className='pr-4' weight='medium' size='2xl'>
            {t('users.title')}
          </Text>
          <div className='flex items-center'>
            <Button color='outlined' className='mr-3' fullWidth onClick={() => setShowAddUsersModal(true)}>
              {t('buttons.add', { ns: 'common' })}
            </Button>
            {cardUsersStore.data.length > 0 && (
              <Button color='outlined' onClick={() => setShowRemoveUsersModal(true)}>
                {t('buttons.remove', { ns: 'common' })}
              </Button>
            )}
          </div>
        </div>
        {cardUsersStore.loading ? (
          <Spinner />
        ) : (
          <div className='flex flex-wrap gap-6'>
            {cardUsersStore.data.length > 0 ? (
              cardUsersStore.data.map((manager, idx) => (
                <Link key={idx} to={RoutePaths.user.onNavigate(manager.id)}>
                  <UserItem letter={manager.firstName.split('')[0]} name={`'${manager.firstName} ${manager.lastName}`} />
                </Link>
              ))
            ) : (
              <NoData />
            )}
          </div>
        )}
      </div>
      <AddUsersModal
        show={showAddUsersModal}
        onClose={() => setShowAddUsersModal(false)}
        cardId={props.cardId}
        usersList={usersListStore.data.filter((manager) => !cardUsersStore.data?.map((m) => m.id).includes(manager.id))}
      />
      <RemoveUsersModal
        show={showRemoveUsersModal}
        onClose={() => setShowRemoveUsersModal(false)}
        cardId={props.cardId}
        usersList={cardUsersStore.data}
      />
    </>
  );
};
